<mat-accordion class="itinerary-route">
  <div class="btnAddRoute">
     <button type="button"
              class="route-btn"
              (click)="addNewRoute()">
                Add Route
      </button></div>

      <div class="container" >
        <div class="one" >
        <mat-selection-list 
           #routeSelection
           [ngClass]="{'mat-elevation-z3':itineraryRouteList.length}">
           
            <mat-list-option
            [value]="route"
            *ngFor="let route of itineraryRouteList" 
            class="list-item"
            [selected]="routeFlag"
            checkboxPosition="before"
            >
            <!-- <span class="list-item-name" *ngFor="let route of itineraryRouteList; let i = index " (click) = "deleteRoute(i)" >
              <mat-icon>clear</mat-icon>
            </span> -->
              <span  class="list-item-name" matTooltip={{route.name}}>
                {{route.name}}  
              </span>  
        </mat-list-option>
        </mat-selection-list>
      </div>
      <button class="name"  *ngFor="let route of itineraryRouteList; let i = index " (click) = "deleteRoute(i)">
        <mat-icon>clear</mat-icon>
          </button>
      </div>
</mat-accordion> 